import { SLOTS_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import {
  IOverBookingHairCutToBathPropsBody,
  IOverBookingHairCutToBathResponse,
} from "@/api_framework/api_modals/Bookings";
import AxiosCurlirize from "axios-curlirize";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useOverBookingHairCutToBathAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filterParams: IOverBookingHairCutToBathPropsBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios

          .post(SLOTS_APIS?.HAIR_CUT_TO_BATH?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IOverBookingHairCutToBathResponse>) => {
            if (res.data.status === true) {
              //
              toast.success("Haircut to bath done.");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
              toast.error("Error while Covert to H2B ");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
